import {
  AnyMerchant,
  BillingDetails,
  UpdateMerchantBillingSettingsRequest,
} from 'api/merchant/dashboard/merchants.types';

import { AddressModalForm } from '../../partials/address-modal/types';
import { NotificationEmailsModalForm } from '../../partials/notification-emails-modal/types';

type ToNotificationEmailsModalFormType = (billingDetails: BillingDetails) => NotificationEmailsModalForm;
type ToUpdateMerchantBillingSettingsRequestType = (
  modalForm: NotificationEmailsModalForm | AddressModalForm,
  standardMerchant: AnyMerchant,
) => UpdateMerchantBillingSettingsRequest;

export const toNotificationEmailsModalForm: ToNotificationEmailsModalFormType = (billingDetails: BillingDetails) => ({
  enabled: billingDetails.billingNotificationsEnabled,
  emailList: billingDetails.billingNotificationEmails || [],
  enteredEmail: '',
});

export const toUpdateMerchantBillingSettingsRequest: ToUpdateMerchantBillingSettingsRequestType = (
  modalForm: NotificationEmailsModalForm | AddressModalForm,
  merchant: AnyMerchant,
) => ({
  UpdateMerchantBillingSettings: {
    billingNotificationEmails:
      'emailList' in modalForm ? modalForm.emailList : merchant.billingDetails.billingNotificationEmails,
    billingNotificationsEnabled:
      'enabled' in modalForm ? modalForm.enabled : merchant.billingDetails.billingNotificationsEnabled,
    billingAddress:
      'address' in modalForm
        ? modalForm.address
        : merchant.billingDetails.billingAddress || merchant.businessProfile.address,
  },
});
